module.exports = __webpack_public_path__ + "static/media/Franklin-Palmer-bylaws.7045efcd.pdf";